import React from 'react';
import { PsBeaconLoadingSpinner, PsBeaconIcon } from '../components/shared/BeaconRegister';

const LoadingSpinner = ({ id, scale, text }) => {
    return (
        <>
            <PsBeaconIcon data-testid="loading-spinner" slot='prefix' id={`loading-spinner-icon-${id}`} style={{ paddingTop: '2px' }}>
                <PsBeaconLoadingSpinner aria-label='loading-spinner' scale={scale}/>
            </PsBeaconIcon>
            <span id='spinner-text'>{text}</span>
        </>
    );
}

export default LoadingSpinner;

